<template>
  <div class="maintenance-wrapper bg-light min-vh-100 font-inter page-wrapper">
    <div class="content container-fluid py-4 bao-duong-page">
      <!-- HEADER -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 class="font-weight-bold text-dark mb-0">
            <i class="fa fa-wrench text-primary mr-2"></i>
            Quản lý Bảo dưỡng & Sửa chữa
          </h4>
          <p class="text-muted mb-0 small">
            Theo dõi sức khỏe đội xe tải & xe cẩu
          </p>
        </div>

        <div class="d-flex align-items-center">
          <select
            class="form-control form-control-sm mr-2"
            v-model.number="pageSize"
            @change="changeSize"
            style="width: 80px"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
          </select>

          <button
            class="btn btn-primary shadow-sm font-weight-bold btn-sm"
            @click="openCreateModal"
          >
            <i class="fa fa-plus-circle mr-1"></i> Tạo Phiếu Mới
          </button>
        </div>
      </div>

      <!-- KPI ROW -->
      <div class="row mb-4">
        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-danger">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small
                    class="text-uppercase text-muted font-weight-bold"
                    style="font-size: 0.7rem"
                  >
                    Sự cố / SOS (Mới)
                  </small>
                  <h2 class="mb-0 text-danger font-weight-bold">
                    {{ kpiStats.critical }}
                  </h2>
                </div>
                <div class="icon-circle bg-light-danger text-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-warning">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small
                    class="text-uppercase text-muted font-weight-bold"
                    style="font-size: 0.7rem"
                  >
                    Đang sửa chữa
                  </small>
                  <h2 class="mb-0 text-warning font-weight-bold">
                    {{ kpiStats.repairing }}
                  </h2>
                </div>
                <div class="icon-circle bg-light-warning text-warning">
                  <i class="fa fa-tools"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-info">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small
                    class="text-uppercase text-muted font-weight-bold"
                    style="font-size: 0.7rem"
                  >
                    Chờ thanh toán
                  </small>
                  <h2 class="mb-0 text-info font-weight-bold">
                    {{ kpiStats.payment }}
                  </h2>
                </div>
                <div class="icon-circle bg-light-info text-info">
                  <i class="fa fa-file-invoice-dollar"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-success">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small
                    class="text-uppercase text-muted font-weight-bold"
                    style="font-size: 0.7rem"
                  >
                    Chi phí đã ghi nhận
                  </small>
                  <h5 class="mb-0 text-success font-weight-bold">
                    {{ formatCurrency(kpiStats.costMonth) }}
                  </h5>
                </div>
                <div class="icon-circle bg-light-success text-success">
                  <i class="fa fa-coins"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MAIN CARD: FILTER + LIST -->
      <div class="card border-0 shadow-sm">
        <div class="card-header bg-white border-bottom-0 py-3">
          <div
            class="d-flex flex-wrap align-items-center justify-content-between gap-2"
          >
            <!-- STATUS PILLS -->
            <ul class="nav nav-pills filter-pills mb-0">
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: filterTrangThai === null }"
                  href="#"
                  @click.prevent="applyFilter(null)"
                >
                  Tất cả
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: filterTrangThai === 'MOI' }"
                  href="#"
                  @click.prevent="applyFilter('MOI')"
                >
                  Mới
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: filterTrangThai === 'DANG_SUA' }"
                  href="#"
                  @click.prevent="applyFilter('DANG_SUA')"
                >
                  Đang sửa
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: filterTrangThai === 'CHO_THANH_TOAN' }"
                  href="#"
                  @click.prevent="applyFilter('CHO_THANH_TOAN')"
                >
                  Chờ thanh toán
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: filterTrangThai === 'HOAN_THANH' }"
                  href="#"
                  @click.prevent="applyFilter('HOAN_THANH')"
                >
                  Hoàn thành
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: filterTrangThai === 'DA_HUY' }"
                  href="#"
                  @click.prevent="applyFilter('DA_HUY')"
                >
                  Đã hủy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="card-body p-0">
          <!-- LOADING -->
          <div
            v-if="isLoadingList && items.length === 0"
            class="p-4 text-center"
          >
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 mb-0 text-muted">Đang tải danh sách phiếu...</p>
          </div>

          <!-- ERROR -->
          <div
            v-else-if="listError && items.length === 0"
            class="alert alert-danger m-3"
          >
            <i class="fa fa-exclamation-triangle mr-2"></i>
            {{ listError }}
            <button class="btn btn-sm btn-danger ml-2" @click="fetchList">
              Thử lại
            </button>
          </div>

          <!-- EMPTY -->
          <div
            v-else-if="items.length === 0"
            class="text-center py-5 text-muted"
          >
            <i class="fa fa-folder-open fa-3x mb-3 text-light-gray"></i>
            <p class="mb-0">
              Không có phiếu nào
              {{
                filterTrangThai
                  ? 'ở trạng thái "' + formatTrangThai(filterTrangThai) + '"'
                  : ""
              }}.
            </p>
          </div>

          <!-- TABLE DESKTOP -->
          <div v-else>
            <div class="table-responsive d-none d-md-block">
              <table class="table table-hover align-middle mb-0 custom-table">
                <thead class="bg-light">
                  <tr
                    class="text-uppercase text-muted small font-weight-bold"
                  >
                    <th class="pl-4 border-0">Phương tiện</th>
                    <th class="border-0">Hạng mục / Nội dung</th>
                    <th class="border-0">Trạng thái</th>
                    <th class="border-0">Chi phí</th>
                    <th class="border-0">Người tạo</th>
                    <th class="text-right pr-4 border-0">Tác vụ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.id"
                    class="cursor-pointer"
                    @click="openDetailModal(item.id)"
                  >
                    <!-- PHƯƠNG TIỆN -->
                    <td class="pl-4">
                      <div class="d-flex align-items-center">
                        <div
                          class="vehicle-icon mr-3"
                          :class="
                            (item.loaiXe || item.xeLoai) === 'CAU'
                              ? 'bg-warning-soft'
                              : 'bg-primary-soft'
                          "
                        >
                          <i
                            class="fa"
                            :class="
                              (item.loaiXe || item.xeLoai) === 'CAU'
                                ? 'fa-truck-loading'
                                : 'fa-truck'
                            "
                          ></i>
                        </div>
                        <div>
                          <div class="font-weight-bold text-dark">
                            {{ item.xeBienSo || 'Chưa gán xe' }}
                          </div>
                          <small class="text-muted">
                            {{ item.loaiXe || item.xeLoai || 'Xe tải' }}
                          </small>
                        </div>
                      </div>
                    </td>

                    <!-- HẠNG MỤC / NỘI DUNG -->
                    <td>
                      <span
                        class="badge mb-1"
                        :class="getLoaiBadge(item.loaiBaoDuong)"
                      >
                        {{ formatLoai(item.loaiBaoDuong) }}
                      </span>
                      <div
                        class="text-truncate font-weight-500"
                        style="max-width: 280px"
                      >
                        {{
                          item.noiDungCongViec ||
                          item.tenHangMuc ||
                          'Không có mô tả'
                        }}
                      </div>
                      <small class="text-muted" v-if="item.huongXuLy">
                        <i class="fa fa-arrow-right mr-1"></i>
                        {{ formatHuongXuLy(item.huongXuLy) }}
                      </small>
                    </td>

                    <!-- TRẠNG THÁI -->
                    <td>
                      <div class="d-flex align-items-center">
                        <span
                          class="status-dot mr-2"
                          :class="getStatusDotClass(item.trangThai)"
                        ></span>
                        <span class="font-weight-bold small text-dark">
                          {{ formatTrangThai(item.trangThai) }}
                        </span>
                      </div>
                    </td>

                    <!-- CHI PHÍ -->
                    <td>
                      <div
                        v-if="item.chiPhiThucTe"
                        class="font-weight-bold text-dark"
                      >
                        {{ formatCurrency(item.chiPhiThucTe) }}
                      </div>
                      <div
                        v-else-if="item.giaDuocDuyet"
                        class="text-success small"
                      >
                        ~{{ formatCurrency(item.giaDuocDuyet) }} (Đã duyệt)
                      </div>
                      <div
                        v-else-if="item.giaDeXuat"
                        class="text-warning small"
                      >
                        ~{{ formatCurrency(item.giaDeXuat) }} (Đề xuất)
                      </div>
                      <div v-else class="text-muted">-</div>
                    </td>

                    <!-- NGƯỜI TẠO -->
                    <td>
                      <div class="small">
                        {{ item.tenNguoiTao || 'Hệ thống' }}
                      </div>
                      <small class="text-muted">
                        {{ formatDate(item.ngayTao) }}
                      </small>
                    </td>

                    <!-- ACTION -->
                    <td class="text-right pr-4">
                      <button
                        class="btn btn-sm btn-light text-primary hover-scale"
                        @click.stop="openDetailModal(item.id)"
                      >
                        <i class="fa fa-angle-right"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- MOBILE CARD LIST -->
            <div class="d-md-none">
              <div
                v-for="item in items"
                :key="'m-' + item.id"
                class="bao-duong-item-card"
                @click="openDetailModal(item.id)"
              >
                <div
                  class="d-flex justify-content-between align-items-center mb-1"
                >
                  <div class="font-weight-bold">
                    {{ item.xeBienSo || 'Chưa gán xe' }}
                  </div>
                  <span
                    class="badge"
                    :class="getStatusBadge(item.trangThai)"
                  >
                    {{ formatTrangThai(item.trangThai) }}
                  </span>
                </div>

                <div class="small text-muted mb-1">
                  Người tạo:
                  <strong>{{ item.tenNguoiTao || 'Hệ thống' }}</strong>
                </div>

                <div class="mb-1">
                  <strong>
                    {{ item.tenHangMuc || 'Sửa chữa / bảo dưỡng' }}
                  </strong>
                  <div class="small text-muted">
                    {{
                      item.noiDungCongViec ||
                      'Không có mô tả chi tiết công việc'
                    }}
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between align-items-center mb-1"
                >
                  <div class="small">
                    <span
                      class="badge"
                      :class="getLoaiBadge(item.loaiBaoDuong)"
                    >
                      {{ formatLoai(item.loaiBaoDuong) }}
                    </span>
                    <span
                      v-if="item.huongXuLy"
                      class="badge badge-light border ml-1"
                    >
                      {{ formatHuongXuLy(item.huongXuLy) }}
                    </span>
                  </div>

                  <div class="small text-right">
                    <div>
                      <span
                        v-if="item.chiPhiThucTe"
                        class="text-danger font-weight-bold"
                      >
                        {{ formatCurrency(item.chiPhiThucTe) }}
                      </span>
                      <span
                        v-else-if="item.giaDuocDuyet"
                        class="text-success"
                      >
                        {{ formatCurrency(item.giaDuocDuyet) }}
                      </span>
                      <span
                        v-else-if="item.giaDeXuat"
                        class="text-warning"
                      >
                        {{ formatCurrency(item.giaDeXuat) }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </div>
                    <div class="text-muted small">
                      {{ formatDate(item.ngayTao) }}
                    </div>
                  </div>
                </div>

                <div class="text-right">
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click.stop="openDetailModal(item.id)"
                  >
                    <i class="fa fa-eye"></i> Xem chi tiết
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- PAGINATION -->
          <div
            v-if="totalPages > 1"
            class="p-3 d-flex justify-content-between align-items-center border-top pagination-wrapper"
          >
            <small class="text-muted">
              Tổng: {{ totalElements }} phiếu — Trang {{ currentPage }}/{{
                totalPages
              }}
            </small>

            <ul class="pagination pagination-sm mb-0">
              <li
                class="page-item"
                :class="{ disabled: currentPage === 1 }"
              >
                <a
                  href="#"
                  class="page-link"
                  @click.prevent="goPage(currentPage - 1)"
                  >Trước</a
                >
              </li>
              <li
                v-for="p in totalPages"
                :key="p"
                class="page-item"
                :class="{ active: p === currentPage }"
              >
                <a
                  href="#"
                  class="page-link"
                  @click.prevent="goPage(p)"
                  >{{ p }}</a
                >
              </li>
              <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages }"
              >
                <a
                  href="#"
                  class="page-link"
                  @click.prevent="goPage(currentPage + 1)"
                  >Sau</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- MODAL: TẠO / CHI TIẾT BẢO DƯỠNG + CHAT -->
      <div v-if="showModal" class="modal-backdrop-custom">
        <div class="custom-modal shadow-lg animate-slide-up">
          <!-- HEADER -->
          <div
            class="modal-header d-flex justify-content-between align-items-start bg-white border-bottom-0 pb-0"
          >
            <div>
              <h5 class="font-weight-bold mb-1" v-if="!isEdit">
                Tạo Yêu Cầu Sửa Chữa Mới
              </h5>
              <template v-else>
                <h5 class="font-weight-bold mb-1">
                  #{{ currentTicket && currentTicket.id }} -
                  {{ currentTicket && (currentTicket.xeBienSo || 'Chưa gán xe') }}
                </h5>
                <div
                  v-if="currentTicket"
                  class="d-flex align-items-center flex-wrap gap-2"
                >
                  <span
                    class="badge badge-pill px-3 py-1"
                    :class="getStatusBadge(currentTicket.trangThai)"
                  >
                    {{ formatTrangThai(currentTicket.trangThai) }}
                  </span>
                  <span class="text-muted small">
                    <i class="fa fa-clock mr-1"></i>
                    {{ formatDateTime(currentTicket.ngayTao) }}
                  </span>
                </div>
              </template>

              <div v-if="formError" class="text-danger small mt-2">
                <i class="fa fa-exclamation-circle mr-1"></i>
                {{ formError }}
              </div>
            </div>

            <button
              class="btn btn-sm btn-light rounded-circle"
              @click="closeModal"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>

          <!-- BODY -->
          <div class="modal-body row pt-3">
            <!-- LEFT COLUMN: THÔNG TIN & FORM -->
            <div class="col-lg-7 border-right pr-lg-4 scrollable-col">
              <h6
                class="text-uppercase text-muted small font-weight-bold mb-3 border-bottom pb-2"
              >
                Thông tin kỹ thuật
              </h6>

              <!-- CREATE MODE -->
              <div v-if="!isEdit">
                <div class="form-row">
                  <div class="col-md-6 form-group">
                    <label class="small font-weight-bold text-dark">
                      Phương tiện
                    </label>
                    <select
                      v-model="form.xeId"
                      class="form-control custom-input"
                      :disabled="isLoadingOptions"
                    >
                      <option :value="null">-- Chọn xe --</option>
                      <option
                        v-for="xe in xeOptions"
                        :key="xe.id"
                        :value="xe.id"
                      >
                        {{ xe.bienSo }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6 form-group">
                    <label class="small font-weight-bold text-dark">
                      Loại bảo dưỡng
                    </label>
                    <select
                      v-model="form.loaiBaoDuong"
                      class="form-control custom-input"
                    >
                      <option :value="null">-- Chọn loại --</option>
                      <option value="DINH_KY">Định kỳ</option>
                      <option value="TU_CHECKLIST">Sự cố Checklist</option>
                      <option value="SU_CO_DOT_XUAT">Sự cố đột xuất</option>
                    </select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-6 form-group">
                    <label class="small font-weight-bold text-dark">
                      Hạng mục (nếu có)
                    </label>
                    <select
                      v-model="form.dmHangMucId"
                      class="form-control custom-input"
                    >
                      <option :value="null">-- Không chọn --</option>
                      <option
                        v-for="opt in dmBaoDuongOptions"
                        :key="opt.id"
                        :value="opt.id"
                      >
                        {{ opt.tenHangMuc || opt.ten || opt.label || opt.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6 form-group">
                    <label class="small font-weight-bold text-dark">
                      ODO lúc tạo (km / giờ máy)
                    </label>
                    <input
                      type="number"
                      v-model.number="form.odoLucTao"
                      class="form-control custom-input"
                      placeholder="Nhập số km / giờ máy"
                    />
                  </div>
                </div>

                <!-- Bộ phận / vị trí -->
                <div class="form-row">
                  <div class="col-md-4 form-group">
                    <label class="small font-weight-bold text-dark">
                      Bộ phận
                    </label>
                    <input
                      type="text"
                      v-model="form.boPhanChinh"
                      class="form-control custom-input"
                      placeholder="VD: Lốp, Thủy lực..."
                    />
                  </div>
                  <div class="col-md-4 form-group">
                    <label class="small font-weight-bold text-dark">
                      Vị trí
                    </label>
                    <input
                      type="text"
                      v-model="form.viTriBoPhan"
                      class="form-control custom-input"
                      placeholder="VD: Trái sau, Phải trước..."
                    />
                  </div>
                  <div class="col-md-4 form-group">
                    <label class="small font-weight-bold text-dark">
                      Chi tiết
                    </label>
                    <input
                      type="text"
                      v-model="form.moTaBoPhanChiTiet"
                      class="form-control custom-input"
                      placeholder="Chi tiết thêm"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label class="small font-weight-bold text-dark">
                    Nội dung sự cố / Công việc
                  </label>
                  <textarea
                    class="form-control custom-input"
                    rows="3"
                    v-model="form.noiDungCongViec"
                    placeholder="Mô tả chi tiết hư hỏng, triệu chứng..."
                  ></textarea>
                </div>

                <!-- ẢNH SỰ CỐ (CREATE: vẫn 1 ảnh) -->
                <div class="form-group">
                  <label class="small font-weight-bold text-dark">
                    Hình ảnh hiện trường
                  </label>
                  <div class="d-flex align-items-center">
                    <div
                      class="img-preview rounded bg-light d-flex align-items-center justify-content-center text-muted border-dashed"
                      style="width: 80px; height: 80px; cursor: pointer"
                      @click="form.anhSuCoUrl ? openLightbox(form.anhSuCoUrl) : openCamera('form_anhSuCoUrl')"
                    >
                      <img
                        v-if="form.anhSuCoUrl"
                        :src="form.anhSuCoUrl"
                        alt="Ảnh sự cố"
                        class="img-fluid rounded"
                      />
                      <i v-else class="fa fa-camera fa-lg"></i>
                    </div>
                    <div class="ml-3">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary mr-2"
                        @click="openPicker('form_anhSuCoUrl')"
                      >
                        <i class="fa fa-folder-open mr-1"></i> Chọn ảnh
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        @click="openCamera('form_anhSuCoUrl')"
                      >
                        <i class="fa fa-camera mr-1"></i> Chụp nhanh
                      </button>
                      <div class="small text-muted mt-1">
                        Nên chụp rõ vị trí hư hỏng & biển số xe.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-3">
                  <button
                    class="btn btn-primary px-4 shadow-sm"
                    @click="submitCreateForm"
                    :disabled="uploading"
                  >
                    <span v-if="uploading" class="spinner-border spinner-border-sm mr-1"></span>
                    Lưu Phiếu Mới
                  </button>
                  <button
                    class="btn btn-outline-secondary px-3 ml-2"
                    type="button"
                    @click="closeModal"
                  >
                    Đóng
                  </button>
                </div>
              </div>

              <!-- EDIT MODE -->
              <div v-else-if="currentTicket">
                <!-- THÔNG TIN CƠ BẢN -->
                <div class="mb-3 pb-2 border-bottom">
                  <div class="row">
                    <!-- Xe -->
                    <div class="col-md-6 mb-2">
                      <label class="small text-muted mb-0">Phương tiện</label>
                      <div class="font-weight-bold">
                        {{ currentTicket.xeBienSo || 'Chưa gán xe' }}
                      </div>
                      <div class="small text-muted">
                        {{ currentTicket.loaiXe || currentTicket.xeLoai || '' }}
                      </div>
                    </div>

                    <!-- Loại bảo dưỡng / hạng mục -->
                    <div class="col-md-6 mb-2">
                      <label class="small text-muted mb-0">Loại bảo dưỡng</label>
                      <div class="font-weight-bold">
                        {{ formatLoai(currentTicket.loaiBaoDuong) }}
                      </div>
                      <div class="small text-muted">
                        {{ currentTicket.tenHangMuc || '' }}
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <!-- ODO lúc tạo -->
                    <div class="col-md-4 mb-2">
                      <label class="small text-muted mb-0">ODO lúc tạo phiếu</label>
                      <div class="font-weight-bold">
                        {{
                          currentTicket.odoLucTao
                            ? currentTicket.odoLucTao + ' km'
                            : 'Không có'
                        }}
                      </div>
                    </div>

                    <!-- Người tạo -->
                    <div class="col-md-4 mb-2">
                      <label class="small text-muted mb-0">Người tạo phiếu</label>
                      <div class="font-weight-bold">
                        {{ currentTicket.tenNguoiTao || 'Không rõ' }}
                      </div>
                    </div>

                    <!-- Thời điểm tạo -->
                    <div class="col-md-4 mb-2">
                      <label class="small text-muted mb-0">Thời điểm tạo</label>
                      <div class="font-weight-bold">
                        {{ formatDateTime(currentTicket.ngayTao) }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ẢNH SỰ CỐ (VIEW: NHIỀU ẢNH) -->
                <div class="mb-3">
                  <label class="small text-muted mb-1">Ảnh sự cố</label>
                  <div v-if="ticketImages.suCo.length" class="img-grid-wrapper">
                    <div
                      v-for="(img, idx) in ticketImages.suCo"
                      :key="'suco-' + idx"
                      class="img-thumb-item"
                      @click="openLightbox(ticketImages.suCo, idx)"
                    >
                      <img :src="img" alt="Ảnh sự cố" />
                    </div>
                  </div>
                  <div v-else class="small text-muted">
                    Không có ảnh sự cố
                  </div>
                </div>

                <!-- Nội dung công việc -->
                <div class="mb-3">
                  <label class="small text-muted mb-0">Nội dung công việc</label>
                  <div class="border rounded p-2 bg-light">
                    {{
                      currentTicket.noiDungCongViec ||
                      'Không có mô tả chi tiết.'
                    }}
                  </div>
                </div>

                <!-- ========== BLOCK 1: HƯỚNG XỬ LÝ / BÁO GIÁ ========== -->
                <template
                  v-if="['MOI','CHO_DUYET','DA_DUYET'].includes(currentTicket.trangThai)"
                >
                  <h6
                    class="text-uppercase text-muted small font-weight-bold mb-2 mt-3"
                  >
                    Hướng xử lý / Báo giá
                  </h6>
                  <div class="card bg-light-primary border-0 mb-3">
                    <div class="card-body p-3">
                      <div class="btn-group w-100 mb-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-white border shadow-sm"
                          :class="{ active: formGia.huongXuLy === 'MUA_PHU_TUNG' }"
                          @click="formGia.huongXuLy = 'MUA_PHU_TUNG'"
                        >
                          🛠️ Mua phụ tùng tự sửa
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-white border shadow-sm"
                          :class="{ active: formGia.huongXuLy === 'RA_GARA' }"
                          @click="formGia.huongXuLy = 'RA_GARA'"
                        >
                          🏭 Đưa xe ra gara
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-white border shadow-sm"
                          :class="{ active: formGia.huongXuLy === 'DAT_LICH_SAU' }"
                          @click="formGia.huongXuLy = 'DAT_LICH_SAU'"
                        >
                          📅 Đặt lịch xử lý sau
                        </button>
                      </div>

                      <div v-if="formGia.huongXuLy === 'RA_GARA'" class="mb-2">
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="Tên gara / nơi sửa đề xuất..."
                          v-model="formGia.garaDeXuat"
                        />
                      </div>

                    <div class="form-group mb-2">
                      <label class="small font-weight-bold mb-1">
                        Ảnh chụp bổ sung (gara / phụ tùng / hiện trường)
                        <small class="text-muted font-weight-normal">
                          ({{ ticketImages.baoGia.length }} ảnh, nếu có)
                        </small>
                      </label>

                      <!-- LIST nhiều ảnh hiện có trên phiếu -->
                      <div
                        v-if="ticketImages.baoGia.length"
                        class="img-grid-wrapper mb-2"
                      >
                        <div
                          class="img-thumb-item"
                          v-for="(img, idx) in ticketImages.baoGia"
                          :key="'bg-edit-' + idx"
                          @click="openLightbox(ticketImages.baoGia, idx)"
                        >
                          <img :src="img" alt="Ảnh bổ sung" />
                        </div>
                      </div>

                      <!-- Khu vực thêm / thay ảnh (giữ nguyên cơ chế 1 ảnh) -->
                      <div class="d-flex align-items-center">
                        <div
                          class="img-preview rounded bg-light d-flex align-items-center justify-content-center text-muted border-dashed"
                          style="width: 70px; height: 70px; cursor: pointer"
                          @click="
                            formGia.anhBaoGiaUrl
                              ? openLightbox(formGia.anhBaoGiaUrl)
                              : openCamera('formGia_anhBaoGiaUrl')
                          "
                        >
                          <img
                            v-if="formGia.anhBaoGiaUrl"
                            :src="formGia.anhBaoGiaUrl"
                            alt="Ảnh báo giá"
                            class="img-fluid rounded"
                          />
                          <i v-else class="fa fa-camera"></i>
                        </div>
                        <div class="ml-2">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary mr-1"
                            @click="openPicker('formGia_anhBaoGiaUrl')"
                          >
                            <i class="fa fa-folder-open mr-1"></i> Chọn
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            @click="openCamera('formGia_anhBaoGiaUrl')"
                          >
                            <i class="fa fa-camera mr-1"></i> Chụp
                          </button>
                        </div>
                      </div>
                    </div>


                      <button
                        type="button"
                        class="btn btn-primary btn-sm font-weight-bold"
                        @click="handleSubmitBaoGia"
                      >
                        Cập nhật Hướng xử lý
                      </button>
                    </div>
                  </div>
                </template>

                <!-- TRẠNG THÁI > MOI: CHỈ HIỂN THỊ TÓM TẮT HƯỚNG XỬ LÝ (READONLY) -->
                <template v-else>
                  <h6
                    class="text-uppercase text-muted small font-weight-bold mb-2 mt-3"
                  >
                    Hướng xử lý
                  </h6>
                  <div class="card border-0 bg-white mb-3">
                    <div class="card-body p-3 small">
                      <div class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Hướng xử lý đã chọn</span>
                        <span class="font-weight-bold">
                          {{
                            currentTicket.huongXuLy
                              ? formatHuongXuLy(currentTicket.huongXuLy)
                              : 'Chưa có'
                          }}
                        </span>
                      </div>
                      <div v-if="currentTicket.garaDeXuat" class="mt-1">
                        <span class="text-muted">Gara / nơi sửa: </span>
                        <strong>{{ currentTicket.garaDeXuat }}</strong>
                      </div>

                      <!-- ẢNH BÁO GIÁ (VIEW: NHIỀU ẢNH) -->
                      <div v-if="ticketImages.baoGia.length" class="mt-2">
                        <span class="text-muted d-block mb-1">Ảnh báo giá:</span>
                        <div class="d-flex flex-wrap gap-2">
                          <img
                            v-for="(img, idx) in ticketImages.baoGia"
                            :key="'bg-' + idx"
                            :src="img"
                            class="img-mini-thumb"
                            @click="openLightbox(ticketImages.baoGia, idx)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- ========== BLOCK 2: KẾT QUẢ SỬA CHỮA ========== -->
                <template v-if="currentTicket.trangThai === 'DANG_SUA'">
                  <h6
                    class="text-uppercase text-muted small font-weight-bold mb-2 mt-3"
                  >
                    Hoàn thành sửa chữa
                  </h6>
                  <div class="card border-0 bg-light mb-3">
                    <div class="card-body p-3 small text-muted">
                      <i class="fa fa-info-circle mr-1"></i>
                      Đang chờ tài xế cập nhật ODO, chi phí thực tế và ảnh biên lai
                      trên giao diện dành cho tài xế.
                    </div>
                  </div>
                </template>

                <template
                  v-else-if="['CHO_THANH_TOAN','HOAN_THANH'].includes(currentTicket.trangThai)"
                >
                  <h6
                    class="text-uppercase text-muted small font-weight-bold mb-2 mt-3"
                  >
                    Kết quả sửa chữa
                  </h6>
                  <div class="card border-0 bg-white mb-3">
                    <div class="card-body p-3 small">
                      <div class="row">
                        <div class="col-md-6 mb-2">
                          <span class="text-muted">ODO khi xong: </span>
                          <strong>
                            {{
                              currentTicket.odoHoanThanh
                                ? currentTicket.odoHoanThanh + ' km'
                                : 'Chưa cập nhật'
                            }}
                          </strong>
                        </div>
                        <div class="col-md-6 mb-2">
                          <span class="text-muted">Chi phí thực tế: </span>
                          <strong>
                            {{
                              currentTicket.chiPhiThucTe
                                ? formatCurrency(currentTicket.chiPhiThucTe)
                                : 'Chưa cập nhật'
                            }}
                          </strong>
                        </div>
                      </div>

                      <!-- ẢNH BIÊN LAI (VIEW: NHIỀU ẢNH) -->
                      <div v-if="ticketImages.bienLai.length" class="mt-2">
                        <span class="text-muted d-block mb-1">Ảnh biên lai:</span>
                        <div class="d-flex flex-wrap gap-2">
                          <img
                            v-for="(img, idx) in ticketImages.bienLai"
                            :key="'bl-' + idx"
                            :src="img"
                            class="img-mini-thumb"
                            @click="openLightbox(ticketImages.bienLai, idx)"
                          />
                        </div>
                      </div>
                      <div v-else class="mt-2 text-muted">
                        <i class="fa fa-image mr-1"></i>
                        Chưa có ảnh biên lai.
                      </div>
                    </div>
                  </div>
                </template>

                <!-- ========== BLOCK 3: THANH TOÁN / HỦY ========== -->
                <template v-if="currentTicket.trangThai === 'CHO_THANH_TOAN'">
                  <h6
                    class="text-uppercase text-muted small font-weight-bold mb-2 mt-3"
                  >
                    Thanh toán / Hủy phiếu
                  </h6>
                  <div class="card border-0 bg-white mb-2">
                    <div class="card-body p-3">
                      <div class="form-group mb-2">
                        <label class="small font-weight-bold">
                          Ghi chú thanh toán
                        </label>
                        <textarea
                          class="form-control form-control-sm"
                          rows="2"
                          v-model="formThanhToan.ghiChu"
                          placeholder="Thêm ghi chú cho kế toán, nếu cần..."
                        ></textarea>
                      </div>

                      <div class="d-flex flex-wrap justify-content-between">
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm mb-1"
                          @click="handleThanhToan"
                        >
                          Xác nhận ĐÃ THANH TOÁN
                        </button>

                        <button
                          type="button"
                          class="btn btn-outline-danger btn-sm mb-1"
                          @click="handleHuyPhieu"
                        >
                          Hủy phiếu
                        </button>

                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm mb-1 ml-auto"
                          @click="closeModal"
                        >
                          Đóng
                        </button>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- TRẠNG THÁI HOÀN THÀNH: TÓM TẮT THANH TOÁN -->
                <template v-else-if="currentTicket.trangThai === 'HOAN_THANH'">
                  <h6
                    class="text-uppercase text-muted small font-weight-bold mb-2 mt-3"
                  >
                    Thông tin thanh toán
                  </h6>
                  <div class="card border-0 bg-white mb-2">
                    <div class="card-body p-3 small">
                      <div class="mb-1">
                        <span class="text-muted">Trạng thái: </span>
                        <strong>ĐÃ HOÀN THÀNH & THANH TOÁN</strong>
                      </div>
                      <div v-if="currentTicket.ghiChuThanhToan" class="mt-1">
                        <span class="text-muted">Ghi chú: </span>
                        <span>{{ currentTicket.ghiChuThanhToan }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-right mt-2">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm"
                      @click="closeModal"
                    >
                      Đóng
                    </button>
                  </div>
                </template>

                <!-- TRẠNG THÁI ĐÃ HỦY -->
                <template v-else-if="currentTicket.trangThai === 'DA_HUY'">
                  <h6
                    class="text-uppercase text-muted small font-weight-bold mb-2 mt-3"
                  >
                    Phiếu đã hủy
                  </h6>
                  <div class="card border-0 bg-white mb-2">
                    <div class="card-body p-3 small">
                      <div class="mb-1">
                        <span class="text-muted">Lý do hủy: </span>
                        <span>{{ currentTicket.lyDoHuy || 'Không rõ' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-right mt-2">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm"
                      @click="closeModal"
                    >
                      Đóng
                    </button>
                  </div>
                </template>
              </div>

              <!-- nếu không có currentTicket (edge case) -->
              <div v-else class="text-muted small">
                Không tải được dữ liệu phiếu.
              </div>
            </div>

            <!-- RIGHT COLUMN: CHAT + TÓM TẮT -->
            <div class="col-lg-5 pl-lg-4 d-flex flex-column h-100">
              <!-- NHANH: TRẠNG THÁI + GIÁ THAM KHẢO -->
              <div
                v-if="isEdit && currentTicket"
                class="card border-0 mb-3 bg-light"
              >
                <div class="card-body p-3 small">
                  <div class="d-flex justify-content-between mb-1">
                    <span class="text-muted">Trạng thái hiện tại</span>
                    <span
                      class="badge"
                      :class="getStatusBadge(currentTicket.trangThai)"
                    >
                      {{ formatTrangThai(currentTicket.trangThai) }}
                    </span>
                  </div>

                  <div v-if="giaThamKhao && giaThamKhao.length">
                    <hr class="my-2" />
                    <div class="text-muted mb-1">
                      Giá tham khảo (theo hạng mục):
                    </div>
                    <ul class="pl-3 mb-0">
                      <li
                        v-for="g in giaThamKhao"
                        :key="g.id || g.tenHangMuc"
                      >
                        <strong>
                          {{ g.tenHangMuc || g.ten || 'Hạng mục' }}:
                        </strong>
                        {{ formatCurrency(g.giaTrungBinh || g.gia || 0) }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- CHAT -->
              <div
                class="card border-0 flex-grow-1 d-flex flex-column chat-card"
              >
                <div
                  class="bg-light p-2 border-bottom small font-weight-bold text-muted d-flex justify-content-between align-items-center"
                >
                  <span>Trao đổi nội bộ</span>
                  <span v-if="currentTicket" class="text-secondary">
                    Phiếu #{{ currentTicket.id }}
                  </span>
                </div>

                <div class="chat-body">
                  <div
                    class="chat-messages"
                    :class="{ 'is-loading': isLoadingChat }"
                  >
                    <!-- LOADING / ERROR -->
                    <div
                      v-if="isLoadingChat"
                      class="text-center text-muted small my-2"
                    >
                      <span class="spinner-border spinner-border-sm mr-1"></span>
                      Đang tải lịch sử trao đổi...
                    </div>
                    <div
                      v-else-if="chatError"
                      class="text-danger small my-2 text-center"
                    >
                      <i class="fa fa-exclamation-circle mr-1"></i>
                      {{ chatError }}
                    </div>

                    <!-- MESSAGES -->
                    <template v-else>
                      <div
                        v-for="(m, idx) in chatMessages"
                        :key="m.id || idx"
                      >
                        <!-- Header ngày -->
                        <div
                          v-if="m.type === 'header'"
                          class="chat-date-header"
                        >
                          {{ m.label }}
                        </div>

                        <!-- Tin nhắn -->
                        <div
                          v-else
                          class="chat-message"
                          :class="{ me: m.isMine }"
                        >
                          <div class="chat-bubble">
                            <div class="chat-meta">
                              <span class="chat-from">{{ m.fromName }}</span>
                              <span
                                v-if="m.toName"
                                class="chat-arrow"
                              >
                                →
                              </span>
                              <span
                                v-if="m.toName"
                                class="chat-to"
                              >
                                {{ m.toName }}
                              </span>
                            </div>

                            <div
                              v-if="m.text"
                              class="chat-text"
                            >
                              {{ m.text }}
                            </div>

                            <div
                              v-if="m.attachmentUrl"
                              class="chat-img-wrapper"
                            >
                              <img
                                :src="m.attachmentUrl"
                                alt="Đính kèm"
                                class="chat-img"
                                @click="openLightbox(m.attachmentUrl)"
                              />
                            </div>

                            <div class="chat-time">
                              {{
                                m.createdAt
                                  ? formatDateTime(m.createdAt)
                                  : ''
                              }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="!chatMessages.length && !isLoadingChat"
                        class="text-muted small text-center mt-2"
                      >
                        Chưa có tin nhắn nào trong phiếu này.
                      </div>
                    </template>
                  </div>
                </div>

                <!-- INPUT -->
                <div class="p-2 border-top bg-light">
                  <div class="input-group input-group-sm">
                    <input
                      type="text"
                      class="form-control border-0"
                      placeholder="Nhập tin nhắn..."
                      v-model="chatForm.text"
                      @keyup.enter="handleSendChat"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-light"
                        type="button"
                        @click="openPicker('chat_attachment')"
                      >
                        <i class="fa fa-paperclip"></i>
                      </button>
                      <button
                        class="btn btn-light"
                        type="button"
                        @click="openCamera('chat_attachment')"
                      >
                        <i class="fa fa-camera"></i>
                      </button>
                      <button
                        class="btn btn-primary"
                        type="button"
                        :disabled="isSendingChat"
                        @click="handleSendChat"
                      >
                        <span
                          v-if="isSendingChat"
                          class="spinner-border spinner-border-sm"
                        ></span>
                        <i
                          v-else
                          class="fa fa-paper-plane"
                        ></i>
                      </button>
                    </div>
                  </div>

                  <BaoDuongChatActionPanel
                    v-if="isEdit && currentTicket"
                    class="mt-1"
                    :ticket="currentTicket"
                    @command="handleSendChat"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- FOOTER: bỏ qua -->
      </div>

      <!-- FILE MANAGER MODAL -->
      <FileManagerModal
        v-if="pickerOpen"
        :visible="pickerOpen"
        :folderName="pickerFolder"
        :tabs="folderTabs"
        @close="closePicker"
        @picked="handleFilePicked"
      />

      <!-- CAMERA CAPTURE -->
      <CameraCapture
        v-if="cameraOpen"
        @close="closeCamera"
        @success="handleCaptureSuccess"
        @error="handleCaptureError"
      />

      <!-- LIGHTBOX -->
      <VueEasyLightbox
        :visible="lightbox.visible"
        :imgs="lightbox.imgs"
        :index="lightbox.index"
        @hide="handleHideLightbox"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useBaoDuongXeStore } from "@/stores/baoDuongXeStore";
import api from "@/api";
import FileManagerModal from "@/components/FileManagerModal.vue";
import CameraCapture from "@/components/CameraCapture.vue";
import fileService from "@/services/fileService";
import VueEasyLightbox from "vue-easy-lightbox";
import BaoDuongChatActionPanel from "@/views/BaoDuongChatActionPanel.vue";
import { useNotificationStore } from "@/stores/notificationStore"; // 👈 THÊM

// === Helpers format ===
function pad2(n) {
  return String(n).padStart(2, "0");
}
function parseIsoLocal(s) {
  if (!s) return null;
  if (s instanceof Date) return s;
  const m = String(s).match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/
  );
  if (!m) return null;
  const [, y, M, d, h, mi, se] = m;
  return new Date(+y, +M - 1, +d, +h, +mi, +se);
}
function formatDate(s) {
  const d = parseIsoLocal(s);
  if (!d) return "-";
  const dd = pad2(d.getDate());
  const MM = pad2(d.getMonth() + 1);
  const yyyy = d.getFullYear();
  return `${dd}/${MM}/${yyyy}`;
}
function formatDateTime(s) {
  const d = parseIsoLocal(s);
  if (!d) return "-";
  const dd = pad2(d.getDate());
  const MM = pad2(d.getMonth() + 1);
  const yyyy = d.getFullYear();
  const hh = pad2(d.getHours());
  const mm = pad2(d.getMinutes());
  return `${dd}/${MM}/${yyyy} ${hh}:${mm}`;
}
function formatCurrency(value) {
  if (value == null || isNaN(Number(value))) return "-";
  return Number(value).toLocaleString("vi-VN") + " đ";
}

// HƯỚNG XỬ LÝ ENUM FE
const HUONG_XU_LY_OPTIONS = [
  { value: "MUA_PHU_TUNG", label: "Mua phụ tùng về tự thay" },
  { value: "RA_GARA", label: "Đưa xe ra gara sửa chữa" },
  { value: "DAT_LICH_SAU", label: "Đặt lịch thay / xử lý sau" },
];

// Form defaults
const DEFAULT_CREATE_FORM = {
  xeId: null,
  loaiBaoDuong: null,
  dmHangMucId: null,
  noiDungCongViec: "",
  odoLucTao: null,
  anhSuCoUrl: "",
  huongXuLy: null,
  boPhanChinh: "",
  viTriBoPhan: "",
  moTaBoPhanChiTiet: "",
};

const DEFAULT_FORM_GIA = {
  garaDeXuat: "",
  giaDeXuat: null,
  anhBaoGiaUrl: null,
  huongXuLy: null,
};

const DEFAULT_FORM_HOAN_THANH = {
  odoHoanThanh: null,
  chiPhiThucTe: null,
  bienLaiUrl: "",
};

const DEFAULT_FORM_THANH_TOAN = {
  ghiChu: "",
};

export default {
  name: "QuanLyBaoDuong",
  components: {
    FileManagerModal,
    CameraCapture,
    VueEasyLightbox,
    BaoDuongChatActionPanel,
  },
  data() {
    return {
      showModal: false,
      isEdit: false,

      form: { ...DEFAULT_CREATE_FORM },
      formError: null,

      formGia: { ...DEFAULT_FORM_GIA },
      formHoanThanh: { ...DEFAULT_FORM_HOAN_THANH },
      formThanhToan: { ...DEFAULT_FORM_THANH_TOAN },

      filters: {
        q: "",
        xeId: null,
        taiXeId: null,
        trangThai: null,
      },

      activeMobileTab: "LIST",

      pickerOpen: false,
      cameraOpen: false,
      pickerFolder: "bao_duong",
      pickerTarget: {
        form: null,
        field: null,
      },
      folderTabs: [],
      uploading: false,

      lightbox: {
        visible: false,
        imgs: [],
        index: 0,
      },

      huongXuLyOptions: HUONG_XU_LY_OPTIONS,

      // CHAT
      chatMessages: [],
      chatForm: {
        text: "",
        attachmentUrl: null,
      },
      isLoadingChat: false,
      isSendingChat: false,
      chatError: null,

      localUserName: (localStorage.getItem("userhoten") || "").trim(),
      localUserRole: (localStorage.getItem("userrole") || "").trim(),
          notiUnsubscribe: null,

    };
  },
  computed: {
    ...mapState(useBaoDuongXeStore, [
      "isLoadingList",
      "listError",
      "items",
      "totalPages",
      "totalElements",
      "size",
      "page",
      "q",
      "filterTrangThai",
      "isLoadingDetail",
      "detailError",
      "currentTicket",
      "giaThamKhao",
      "isLoadingOptions",
      "optionsError",
      "xeOptions",
      "dmBaoDuongOptions",
      "taiXeOptions",
    ]),

    currentPage() {
      return (this.page ?? 0) + 1;
    },

    pageSize: {
      get() {
        return this.size;
      },
      set(v) {
        this.changeSize(v);
      },
    },

    // KPI dựa trên list hiện tại
    kpiStats() {
      const list = this.items || [];
      const critical = list.filter((t) => t.trangThai === "MOI").length;
      const repairing = list.filter((t) => t.trangThai === "DANG_SUA").length;
      const payment = list.filter((t) => t.trangThai === "CHO_THANH_TOAN")
        .length;
      const costMonth = list.reduce(
        (acc, curr) => acc + (curr.chiPhiThucTe || 0),
        0
      );
      return { critical, repairing, payment, costMonth };
    },

    // Gom ảnh: sự cố / báo giá / biên lai (đa ảnh + fallback url đơn)
    ticketImages() {
      const t = this.currentTicket;
      if (!t) {
        return { suCo: [], baoGia: [], bienLai: [] };
      }

      const getList = (listProp, strProp) => {
        let res = [];
        if (listProp && Array.isArray(listProp)) {
          res = [...listProp];
        }
        if (res.length === 0 && strProp) {
          res.push(strProp);
        }
        return res;
      };

      return {
        suCo: getList(t.anhSuCoList, t.anhSuCoUrl),
        baoGia: getList(t.anhBaoGiaList, t.anhBaoGiaUrl),
        bienLai: getList(t.anhBienLaiList, t.bienLaiUrl),
      };
    },
  },
  methods: {
    ...mapActions(useBaoDuongXeStore, [
      "fetchList",
      "setPage",
      "setSize",
      "fetchOptionsIfNeeded",
      "openTicketDetail",
      "clearTicketDetail",
      "createTicket",
      "submitGia",
      "completeSuaChua",
      "confirmThanhToan",
      "cancelTicket",
      "setFilterTrangThai",
      "setQuery",
    ]),

     handleRealtimeNotification(n) {
    // chưa mở modal / chưa ở chế độ xem phiếu -> kệ
    if (!this.showModal || !this.isEdit || !this.currentTicket) return;
    if (!n) return;

    // BE phải trả đúng các field này
    const loaiThongBao = n.loaiThongBao || n.type || "";
    const loaiDoiTuong = n.loaiDoiTuong || "";
    const idDoiTuong = n.idDoiTuong;

    // Chỉ xử lý thông báo chat bảo dưỡng, đúng phiếu đang mở
    if (
      loaiThongBao === "BAO_DUONG_XE_CHAT" &&
      loaiDoiTuong === "bao-duong-xe" &&
      idDoiTuong === this.currentTicket.id
    ) {
      // reload lại history chat
      this.loadChatHistory(this.currentTicket.id);

      // nếu muốn, có thể scroll xuống cuối luôn
      this.$nextTick(() => {
        const box = this.$el.querySelector(".chat-messages");
        if (box) box.scrollTop = box.scrollHeight;
      });
    }
  },

    formatDayHeader(dateString) {
      const d = new Date(dateString);
      if (isNaN(d)) return "";

      const now = new Date();

      const isSameDay = (a, b) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);

      if (isSameDay(d, now)) return "Hôm nay";
      if (isSameDay(d, yesterday)) return "Hôm qua";

      const weekdays = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
      const w = weekdays[d.getDay()];

      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${w} ${dd}/${mm}/${yyyy}`;
    },

    normalizeChatMessage(raw) {
      if (!raw) return null;

      const normLocalName = (this.localUserName || "").toUpperCase();
      const localRole = this.localUserRole || "";

      const fromNameRaw = (
        raw.fromName ||
        raw.senderName ||
        raw.nguoiGui ||
        raw.authorName ||
        ""
      ).trim();

      const toNameRaw = (
        raw.toName ||
        raw.receiverName ||
        raw.nguoiNhan ||
        raw.targetName ||
        ""
      ).trim();

      const fromRole = raw.fromRole || raw.senderRole || raw.authorRole || "";
      const toRole = raw.toRole || raw.receiverRole || raw.targetRole || "";

      const isMineByName =
        normLocalName &&
        fromNameRaw &&
        fromNameRaw.toUpperCase() === normLocalName;

      const isMineByRole = localRole && fromRole && localRole === fromRole;

      const isMine = !!(raw.isMine || isMineByName || isMineByRole);

      const fromName =
        fromNameRaw ||
        (isMine ? this.localUserName || "Tôi" : "Không rõ");

      let toName = toNameRaw;
      if (!toName) {
        if (fromRole === "TAI_XE") toName = "Admin";
        else if (fromRole === "ADMIN") toName = "Tài xế";
      }

      return {
        id: raw.id || raw.messageId || Date.now(),
        text: raw.text || raw.noiDung || raw.message || "",
        attachmentUrl: raw.attachmentUrl || raw.anhDinhKemUrl || null,
        createdAt: raw.createdAt || raw.thoiGian || raw.time || null,
        fromName,
        toName,
        fromRole,
        toRole,
        isMine,
      };
    },

    // Lightbox
    openLightbox(target, index = 0) {
      if (Array.isArray(target)) {
        const imgs = target.filter(Boolean);
        if (!imgs.length) return;
        this.lightbox.imgs = imgs;
        this.lightbox.index = index || 0;
      } else if (target) {
        this.lightbox.imgs = [target];
        this.lightbox.index = 0;
      } else {
        return;
      }
      this.lightbox.visible = true;
    },
    handleHideLightbox() {
      this.lightbox.visible = false;
    },

    // Helpers
    formatDate,
    formatDateTime,
    formatCurrency,
    getStatusBadge(status) {
      switch (status) {
        case "MOI":
          return "badge-light";
        case "CHO_DUYET":
          return "badge-warning";
        case "DA_DUYET":
          return "badge-info";
        case "DANG_SUA":
          return "badge-primary";
        case "CHO_THANH_TOAN":
          return "badge-danger";
        case "HOAN_THANH":
          return "badge-success";
        case "DA_HUY":
          return "badge-secondary";
        default:
          return "badge-light";
      }
    },
    getStatusDotClass(status) {
      switch (status) {
        case "MOI":
          return "bg-danger";
        case "CHO_DUYET":
          return "bg-warning";
        case "DA_DUYET":
          return "bg-info";
        case "DANG_SUA":
          return "bg-warning";
        case "CHO_THANH_TOAN":
          return "bg-info";
        case "HOAN_THANH":
          return "bg-success";
        case "DA_HUY":
          return "bg-secondary";
        default:
          return "bg-light";
      }
    },
    formatTrangThai(status) {
      switch (status) {
        case "MOI":
          return "Mới tạo";
        case "CHO_DUYET":
          return "Chờ duyệt giá";
        case "DA_DUYET":
          return "Đã duyệt";
        case "DANG_SUA":
          return "Đang sửa";
        case "CHO_THANH_TOAN":
          return "Chờ thanh toán";
        case "HOAN_THANH":
          return "Hoàn thành";
        case "DA_HUY":
          return "Đã hủy";
        default:
          return status;
      }
    },
    getLoaiBadge(loai) {
      switch (loai) {
        case "DINH_KY":
          return "badge-info";
        case "TU_CHECKLIST":
          return "badge-warning";
        case "SU_CO_DOT_XUAT":
          return "badge-danger";
        default:
          return "badge-light";
      }
    },
    formatLoai(loai) {
      switch (loai) {
        case "DINH_KY":
          return "Định kỳ";
        case "TU_CHECKLIST":
          return "Sự cố Checklist";
        case "SU_CO_DOT_XUAT":
          return "Sự cố Đột xuất";
        default:
          return loai;
      }
    },
    formatHuongXuLy(code) {
      if (!code) return "";
      const found = this.huongXuLyOptions.find((o) => o.value === code);
      return found ? found.label : code;
    },

    // Filter / phân trang
    applyFilters() {
      this.setQuery(this.filters.q || "");
      this.setPage(1);
    },
    applyFilter(status) {
      this.setFilterTrangThai(status);
    },
    changeSize(newSize) {
      this.setSize(Number(newSize));
    },
    goPage(p) {
      if (p < 1 || p > this.totalPages || p === this.currentPage) return;
      this.setPage(p);
    },

    // Modal
    async openCreateModal() {
      this.isEdit = false;
      this.formError = null;
      this.form = { ...DEFAULT_CREATE_FORM };
      this.showModal = true;
      document.body.style.overflow = "hidden";
      await this.fetchOptionsIfNeeded();
    },

    async openDetailModal(ticketId) {
      this.isEdit = true;
      this.formError = null;
      this.formGia = { ...DEFAULT_FORM_GIA };
      this.formHoanThanh = { ...DEFAULT_FORM_HOAN_THANH };
      this.formThanhToan = { ...DEFAULT_FORM_THANH_TOAN };
      this.showModal = true;
      document.body.style.overflow = "hidden";

      await this.openTicketDetail(ticketId);
      await this.fetchOptionsIfNeeded();

      if (this.currentTicket) {
        this.formGia.garaDeXuat = this.currentTicket.garaDeXuat || "";
        this.formGia.giaDeXuat = this.currentTicket.giaDeXuat;
        this.formGia.anhBaoGiaUrl = this.currentTicket.anhBaoGiaUrl;
        this.formGia.huongXuLy = this.currentTicket.huongXuLy || null;

        this.formHoanThanh.odoHoanThanh = this.currentTicket.odoHoanThanh;
        this.formHoanThanh.chiPhiThucTe = this.currentTicket.chiPhiThucTe;
        this.formHoanThanh.bienLaiUrl = this.currentTicket.bienLaiUrl;

        this.formThanhToan.ghiChu =
          this.currentTicket.ghiChuThanhToan || "";
      }

      if (ticketId) {
        this.loadChatHistory(ticketId);
      }
    },

    closeModal() {
      this.showModal = false;
      this.isEdit = false;
      this.clearTicketDetail();
      document.body.style.overflow = "";
      this.chatMessages = [];
      this.chatForm.text = "";
      this.chatForm.attachmentUrl = null;
      this.chatError = null;
    },

    // Submit create
    async submitCreateForm() {
      this.formError = null;
      if (!this.form.xeId || !this.form.loaiBaoDuong || !this.form.noiDungCongViec) {
        this.formError =
          "Vui lòng nhập Xe, Loại bảo dưỡng và Nội dung công việc.";
        return;
      }
      try {
        await this.createTicket(this.form);
        this.closeModal();
        alert("Tạo phiếu sửa chữa thành công!");
      } catch (e) {
        this.formError =
          this.detailError || "Lỗi không xác định khi tạo phiếu.";
      }
    },

    // Báo giá / hướng xử lý
    async handleSubmitBaoGia() {
      this.formError = null;

      if (!this.currentTicket) {
        this.formError = "Không tìm thấy phiếu hiện tại.";
        return;
      }

      if (!this.formGia.huongXuLy) {
        this.formError = "Vui lòng chọn Hướng xử lý.";
        return;
      }

      if (this.formGia.huongXuLy === "RA_GARA") {
        if (!this.formGia.garaDeXuat || !this.formGia.garaDeXuat.trim()) {
          this.formError = "Vui lòng nhập Tên Gara / Nơi sửa.";
          return;
        }
      }

      const payload = {
        huongXuLy: this.formGia.huongXuLy,
        garaDeXuat:
          this.formGia.huongXuLy === "RA_GARA"
            ? this.formGia.garaDeXuat.trim()
            : null,
        giaDeXuat: 0,
        anhBaoGiaUrl: this.formGia.anhBaoGiaUrl || null,
      };

      try {
        await this.submitGia(this.currentTicket.id, payload);
        alert("Đã cập nhật Hướng xử lý cho phiếu.");
        await this.openTicketDetail(this.currentTicket.id);
      } catch (e) {
        this.formError =
          this.detailError || "Lỗi cập nhật Hướng xử lý / báo giá.";
      }
    },

    // Hoàn thành sửa
    async handleHoanThanh() {
      this.formError = null;
      if (
        !this.formHoanThanh.odoHoanThanh ||
        !this.formHoanThanh.chiPhiThucTe ||
        !this.formHoanThanh.bienLaiUrl
      ) {
        this.formError =
          "Vui lòng nhập ODO, Chi phí thực tế và Ảnh biên lai.";
        return;
      }
      if (
        this.formHoanThanh.odoHoanThanh <= 0 ||
        this.formHoanThanh.chiPhiThucTe <= 0
      ) {
        this.formError = "ODO và Chi phí phải là số dương.";
        return;
      }
      try {
        await this.completeSuaChua(this.currentTicket.id, this.formHoanThanh);
        alert("Xác nhận hoàn thành thành công, chờ thanh toán.");
      } catch (e) {
        this.formError = this.detailError || "Lỗi xác nhận hoàn thành.";
      }
    },

    // Thanh toán
    async handleThanhToan() {
      this.formError = null;
      if (!this.currentTicket) return;
      if (!confirm("Xác nhận đã thanh toán cho phiếu này?")) return;
      try {
        await this.confirmThanhToan(
          this.currentTicket.id,
          this.formThanhToan.ghiChu
        );
        alert("Xác nhận thanh toán thành công!");
      } catch (e) {
        this.formError = this.detailError || "Lỗi xác nhận thanh toán.";
      }
    },

    // Hủy phiếu
    async handleHuyPhieu() {
      this.formError = null;
      if (!this.currentTicket) return;
      const lyDo = prompt("Nhập lý do hủy phiếu (bắt buộc):");
      if (!lyDo || lyDo.trim() === "") return;
      if (!confirm("Bạn chắc chắn muốn HỦY phiếu sửa chữa này?")) return;
      try {
        await this.cancelTicket(this.currentTicket.id, lyDo);
        alert("Đã hủy phiếu thành công.");
      } catch (e) {
        this.formError = this.detailError || "Lỗi hủy phiếu.";
      }
    },

    // File Manager & Camera
    async fetchFolders() {
      try {
        this.uploading = true;
        const { data } = await api.get("/api/images/folders");
        this.folderTabs = (data || []).map((folderName, index) => ({
          id: (index + 1).toString(),
          name: folderName,
          folderName,
        }));
      } catch {
        this.folderTabs = [];
        console.error("Lỗi khi tải danh sách folder.");
      } finally {
        this.uploading = false;
      }
    },

    async openPicker(targetKey) {
      if (targetKey === "form_anhSuCoUrl") {
        this.pickerTarget = { form: this.form, field: "anhSuCoUrl" };
        this.pickerFolder = "su_co";
      } else if (targetKey === "formGia_anhBaoGiaUrl") {
        this.pickerTarget = { form: this.formGia, field: "anhBaoGiaUrl" };
        this.pickerFolder = "bao_duong_bao_gia";
      } else if (targetKey === "bienLaiUrl") {
        this.pickerTarget = { form: this.formHoanThanh, field: "bienLaiUrl" };
        this.pickerFolder = "bao_duong_bien_lai";
      } else if (targetKey === "chat_attachment") {
        this.pickerTarget = { form: this.chatForm, field: "attachmentUrl" };
        this.pickerFolder = "bao_duong_chat";
      } else {
        return;
      }

      await this.fetchFolders();
      this.pickerOpen = true;
      document.body.style.overflow = "hidden";
    },

    closePicker() {
      this.pickerOpen = false;
      document.body.style.overflow = "";
    },

    handleFilePicked(image) {
      if (!image || !image.url) {
        alert("Lỗi: File được chọn không có URL.");
        return;
      }
      if (this.pickerTarget.form && this.pickerTarget.field) {
        this.pickerTarget.form[this.pickerTarget.field] = image.url;
      }
      this.closePicker();
    },

    openCamera(targetKey) {
      if (targetKey === "form_anhSuCoUrl") {
        this.pickerTarget = { form: this.form, field: "anhSuCoUrl" };
        this.pickerFolder = "su_co";
      } else if (targetKey === "formGia_anhBaoGiaUrl") {
        this.pickerTarget = { form: this.formGia, field: "anhBaoGiaUrl" };
        this.pickerFolder = "bao_duong_bao_gia";
      } else if (targetKey === "bienLaiUrl") {
        this.pickerTarget = { form: this.formHoanThanh, field: "bienLaiUrl" };
        this.pickerFolder = "bao_duong_bien_lai";
      } else if (targetKey === "chat_attachment") {
        this.pickerTarget = { form: this.chatForm, field: "attachmentUrl" };
        this.pickerFolder = "bao_duong_chat";
      } else {
        return;
      }
      this.cameraOpen = true;
      document.body.style.overflow = "hidden";
    },

    closeCamera() {
      this.cameraOpen = false;
      document.body.style.overflow = "";
    },

    async handleCaptureSuccess(file) {
      this.closeCamera();
      if (!file) return;

      this.uploading = true;
      this.formError = null;
      try {
        const formData = new FormData();
        formData.append("files", file, file.name || "camera-capture.jpg");
        formData.append("folderName", this.pickerFolder);

        const res = await fileService.upload(formData);
        const first = Array.isArray(res.data) ? res.data[0] : null;
        if (first?.location) {
          if (this.pickerTarget.form && this.pickerTarget.field) {
            this.pickerTarget.form[this.pickerTarget.field] =
              first.location;
          }
        } else {
          throw new Error("Server không trả về URL file.");
        }
      } catch (err) {
        const errorMsg =
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "Upload ảnh thất bại";
        console.error("[Upload Camera]", err);
        this.formError = errorMsg;
      } finally {
        this.uploading = false;
      }
    },

    handleCaptureError(error) {
      this.closeCamera();
      this.formError =
        "Lỗi Camera: " + (error.message || "Không thể truy cập camera");
    },

    // ========== CHAT ==========
    async loadChatHistory(ticketId) {
      if (!ticketId) return;

      this.isLoadingChat = true;
      this.chatError = null;

      try {
        const { data } = await api.get(`/api/bao-duong-xe/${ticketId}/chat`);
        const list = Array.isArray(data) ? data : [];

        let messages = list
          .map((m) => this.normalizeChatMessage(m))
          .filter(Boolean);

        messages = messages.slice().sort((a, b) => {
          const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return ta - tb;
        });

        const grouped = [];
        let lastDateKey = null;

        messages.forEach((m) => {
          const d = m.createdAt ? new Date(m.createdAt) : null;
          if (!d || isNaN(d)) {
            grouped.push({ type: "msg", ...m });
            return;
          }

          const dateKey = `${d.getFullYear()}-${String(
            d.getMonth() + 1
          ).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

          if (dateKey !== lastDateKey) {
            grouped.push({
              type: "header",
              label: this.formatDayHeader(d),
            });
            lastDateKey = dateKey;
          }

          grouped.push({
            type: "msg",
            ...m,
          });
        });

        this.chatMessages = grouped;

        this.$nextTick(() => {
          const box = this.$el.querySelector(".chat-messages");
          if (box) box.scrollTop = box.scrollHeight;
        });
      } catch (err) {
        console.error("loadChatHistory error", err);
        this.chatError =
          err?.response?.data?.message ||
          "Không tải được lịch sử trao đổi trong phiếu.";
      } finally {
        this.isLoadingChat = false;
      }
    },

    async handleSendChat() {
      if (!this.currentTicket) return;
      const text = (this.chatForm.text || "").trim();
      const attachmentUrl = this.chatForm.attachmentUrl || null;

      if (!text && !attachmentUrl) return;

      this.isSendingChat = true;
      this.chatError = null;

      try {
        const payload = {
          text,
          attachmentUrl,
        };

        const { data } = await api.post(
          `/api/bao-duong-xe/${this.currentTicket.id}/chat`,
          payload
        );

        const raw = {
          ...(data || {}),
          text: data?.text || text,
          attachmentUrl: data?.attachmentUrl || attachmentUrl,
          fromName: this.localUserName || data?.fromName || "Tôi",
          fromRole: this.localUserRole || data?.fromRole || "ADMIN",
          toName:
            data?.toName ||
            data?.receiverName ||
            (this.localUserRole === "ADMIN" ? "Tài xế" : "Admin"),
          isMine: true,
        };

        const msg = this.normalizeChatMessage(raw);
        if (msg) {
          this.chatMessages.push(msg);
        } else {
          await this.loadChatHistory(this.currentTicket.id);
        }

        this.chatForm.text = "";
        this.chatForm.attachmentUrl = null;

        this.$nextTick(() => {
          const box = this.$el.querySelector(".chat-messages");
          if (box) box.scrollTop = box.scrollHeight;
        });
      } catch (err) {
        this.chatError =
          err?.response?.data?.message || "Gửi tin nhắn thất bại.";
      } finally {
        this.isSendingChat = false;
      }
    },
  },

  mounted() {
    this.filters.q = this.q || "";
    this.fetchList();
    this.fetchOptionsIfNeeded();

    const notificationStore = useNotificationStore();

  this.notiUnsubscribe = notificationStore.$onAction(
    ({ name, args, after }) => {
      if (name === "addNotification") {
        after(() => {
          const n = args[0]; // đối số đầu của addNotification(n)
          this.handleRealtimeNotification(n);
        });
      }
    }
  );
  },
  beforeDestroy() {
  if (this.notiUnsubscribe) {
    this.notiUnsubscribe();
    this.notiUnsubscribe = null;
  }
},
};
</script>

<style scoped>
.font-inter {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
}

.bao-duong-page {
  padding-bottom: 72px;
}

/* KPI Cards */
.kpi-card {
  border-left-width: 4px !important;
  transition: transform 0.2s;
}
.kpi-card:hover {
  transform: translateY(-3px);
}
.border-left-danger {
  border-left-color: #dc3545 !important;
}
.border-left-warning {
  border-left-color: #ffc107 !important;
}
.border-left-info {
  border-left-color: #17a2b8 !important;
}
.border-left-success {
  border-left-color: #28a745 !important;
}

.icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.bg-light-danger {
  background-color: rgba(220, 53, 69, 0.1);
}
.bg-light-warning {
  background-color: rgba(255, 193, 7, 0.1);
}
.bg-light-info {
  background-color: rgba(23, 162, 184, 0.1);
}
.bg-light-success {
  background-color: rgba(40, 167, 69, 0.1);
}

/* Table */
.custom-table th {
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}
.vehicle-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}
.bg-primary-soft {
  background-color: #e3f2fd;
  color: #007bff;
}
.bg-warning-soft {
  background-color: #fff3cd;
  color: #856404;
}
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}
.hover-scale:hover {
  transform: scale(1.1);
}
.cursor-pointer {
  cursor: pointer;
}

/* Filter Pills */
.filter-pills .nav-link {
  border-radius: 20px;
  padding: 6px 16px;
  color: #6c757d;
  font-size: 0.9rem;
  font-weight: 500;
}
.filter-pills .nav-link.active {
  background-color: #343a40;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Cards / table base */
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.table td,
.table th {
  vertical-align: middle;
}
.table thead th {
  background-color: #e9ecef;
  border-bottom-width: 1px;
}
.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.text-truncate {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge {
  padding: 0.35em 0.6em;
  font-size: 0.8rem;
  font-weight: 500;
}
.badge-light {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
}
.badge-warning {
  background-color: #ffc107;
  color: #000;
}
.badge-info {
  background-color: #0dcaf0;
  color: #000;
}
.badge-primary {
  background-color: #0d6efd;
  color: #fff;
}
.badge-danger {
  background-color: #dc3545;
  color: #fff;
}
.badge-success {
  background-color: #198754;
  color: #fff;
}
.badge-secondary {
  background-color: #6c757d;
  color: #fff;
}

/* MOBILE LIST CARD */
.bao-duong-item-card {
  background: #fff;
  border-bottom: 1px solid #e9ecef;
  padding: 0.75rem 0.9rem;
}

/* CUSTOM MODAL OVERLAY */
.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-modal {
  background: #fff;
  width: 90%;
  max-width: 1100px;
  height: 85vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.animate-slide-up {
  animation: slideUp 0.25s ease-out;
}
@keyframes slideUp {
  from {
    transform: translateY(40px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.custom-input {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}
.custom-input:focus {
  background-color: #fff;
  border-color: #80bdff;
  box-shadow: none;
}
.border-dashed {
  border: 2px dashed #dee2e6;
}
.scrollable-col {
  overflow-y: auto;
  max-height: calc(85vh - 120px);
}

/* CHAT BUBBLE UI */
.chat-card {
  display: flex;
  flex-direction: column;
}
.chat-body {
  flex: 0 1 auto;
  padding-bottom: 0;
}
.chat-messages {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
}
.chat-messages.is-loading {
  opacity: 0.7;
}

.chat-date-header {
  text-align: center;
  background: #d8d8d8;
  color: #ffffff;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  margin: 10px auto;
  width: fit-content;
}

.chat-message {
  display: flex;
  margin: 6px 0;
  justify-content: flex-start;
}
.chat-message.me {
  justify-content: flex-end;
}
.chat-bubble {
  display: inline-block;
  flex: 0 0 auto;
  max-width: 70%;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f1f3f5;
  font-size: 13px;
}
.chat-message.me .chat-bubble {
  background: #b9daff;
}
.chat-meta {
  font-size: 11px;
  margin-bottom: 3px;
  color: #555;
}
.chat-message.me .chat-meta {
  text-align: right;
}
.chat-from {
  font-weight: 600;
}
.chat-arrow {
  margin: 0 4px;
}
.chat-to {
  opacity: 0.8;
}
.chat-text {
  white-space: pre-wrap;
  word-break: break-word;
}
.chat-img-wrapper {
  margin-top: 5px;
}
.chat-img {
  max-width: 160px;
  max-height: 160px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #dee2e6;
}
.chat-time {
  margin-top: 3px;
  font-size: 11px;
  color: #666;
  text-align: right;
}

/* IMAGE PREVIEW */
.img-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* GRID ẢNH NHIỀU TẤM (SỰ CỐ / BÁO GIÁ / BIÊN LAI) */
.img-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  gap: 8px;
  margin-top: 4px;
}

.img-thumb-item {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  cursor: pointer;
  position: relative;
}

.img-thumb-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s;
}

.img-thumb-item:active img {
  transform: scale(0.95);
}

.img-mini-thumb {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid #dee2e6;
  cursor: pointer;
}

/* PAGINATION */
.pagination-wrapper {
  padding-bottom: 0.5rem;
}

@media (max-width: 768px) {
  .kpi-card {
    margin-bottom: 10px;
  }
  .custom-modal {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  .modal-body {
    flex-direction: column;
  }
  .modal-body .col-lg-7 {
    border-right: none !important;
    border-bottom: 1px solid #eee;
    margin-bottom: 1rem;
  }
}
</style>
